import { render, staticRenderFns } from "./ZonesPriority.vue?vue&type=template&id=52b7e8ef&scoped=true"
import script from "./ZonesPriority.vue?vue&type=script&lang=js"
export * from "./ZonesPriority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7e8ef",
  null
  
)

export default component.exports